import React from "react";
import { inject, observer } from "mobx-react";

const CampaignInfo = (overallprogress) => {
  
  return (
    <div className="container">
      <div className="therm-container">
        <div
          className=
          {`
              ${overallprogress <= 0
              ? "therm-inner no-point"
              : "therm-inner point"
            }
            `}
          style={{
            width: `
                ${overallprogress.overallprogress}%
              `
          }}
        ></div>
      </div>
    </div>
  );
}

export default (CampaignInfo);
